<template>
    <div >

        <!-- body -->
        <div :key="selectedSlideIndex_n">

            <!-- 1) image -->
            <div>
                <tq-img-fill-blur :p_height_s="p_slideHeight_s" :pp_img-url_s="p_slidesData_ac[selectedSlideIndex_n].sd_imageUrl_s" />
            </div>

            <!-- 2) title and description-->
            <div class="TQ_textAlign_initial TQ_padding_8px TQ_textColor_black">

                <!-- title -->
                <div class="TQ_text_bold">
                    {{p_slidesData_ac[selectedSlideIndex_n].sd_title_s}}
                </div>

                <!-- description -->
                <div >
                    {{p_slidesData_ac[selectedSlideIndex_n].sd_description_s}}
                </div>
            </div>

        </div>

        <!-- bottom bar -->
        <div  class="TQ_grid_col_1frAuto1fr TQ_margin_top_8px TQ_padding_4px" v-if="p_slidesData_ac.length > 1" @click.stop>

            <div class="TQ_grid_verticalCenter TQ_align_initial" >
                <div v-if="selectedSlideIndex_n>0" @click="selectedSlideIndex_n--" class="TQ_clickable TQ_textColor_purple TQ_text_bold">
                    <tq-image :pb_src_r="helper_getDirectionByLangCode_fe(store_langCode_ve.val) === enum_directions.rtl ? ass_img_arrow_head_right_p : ass_img_arrow_head_left_p" class="TQ_width_12px TQ_verticalAlignMiddle "/>
                    <div class="TQ_verticalAlignMiddle TQ_inline TQ_padding_1px"></div>
                    <div class="TQ_verticalAlignMiddle TQ_inline"> {{ ass_strings.oneWord_prev[store_langCode_ve.val] }} </div>
                </div>
            </div>

            <div class="TQ_grid_verticalCenter lc_dots ">
                     <span v-for="(slideData_c, index_n ) in p_slidesData_ac"
                           :class="index_n === selectedSlideIndex_n ? 'lc_dot_selected' : 'lc_dot'"
                           class="TQ_box_shadow TQ_margin_4px"></span>
            </div>

            <div class="TQ_grid_verticalCenter TQ_align_end TQ_text_capitalize ">
                <div v-if="selectedSlideIndex_n < p_slidesData_ac.length - 1" @click="selectedSlideIndex_n++" class="TQ_clickable TQ_textColor_purple TQ_text_bold ">
                    <div class="TQ_verticalAlignMiddle TQ_inline"> {{ ass_strings.oneWord_next[store_langCode_ve.val] }} </div>
                    <div class="TQ_verticalAlignMiddle TQ_inline TQ_padding_1px"></div>
                    <tq-image :pb_src_r="helper_getDirectionByLangCode_fe(store_langCode_ve.val) === enum_directions.rtl ? ass_img_arrow_head_left_p : ass_img_arrow_head_right_p" class="TQ_width_12px TQ_verticalAlignMiddle"/>
                </div>
                <div v-else-if="pe_clickFinish_f" class="TQ_clickable TQ_textColor_purple TQ_text_bold" @click="pe_clickFinish_f ">
                    {{ ass_strings.oneWord_finish[store_langCode_ve.val] }}
                </div>
            </div>
        </div>

    </div>
</template>

<script>


import {validator_arrayClass_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {FB_SlideData} from "../../../functions/src/shareCode/Share_S_Classes";
import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
import {store_getStateValue_vo, store_var} from "@/store";
import {ass_img_arrow_head_left_p, ass_img_arrow_head_right_p} from "@/assets/scripts/Ass_Files";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import TqImage from "@/components/basic/TqImage";
import {enum_directions} from "../../../functions/src/shareCode/Share_S_Enum";
import {helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";
import TqPopup from "@/components/basic/TqPopup";

export default {
    name: "FccDisplaySlidesData",
    components: {TqPopup, TqImage, TqImgFillBlur},
    props:{
        p_slidesData_ac:{
            type: Array,
            require: true,
            validator(arr){
                return validator_arrayClass_fb(arr, FB_SlideData)
            }
        },
        p_slideHeight_s:{
            type: String,
            default: '200px'
        },
        pe_clickFinish_f: {
            type: Function,
        }
    },
    data(){
        return {
            selectedSlideIndex_n : 0,
            store_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

            // import
            helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
            ass_strings : ass_strings,
            enum_directions : enum_directions,
            ass_img_arrow_head_right_p : ass_img_arrow_head_right_p,
            ass_img_arrow_head_left_p : ass_img_arrow_head_left_p,

        }
    },

}
</script>

<style scoped>

    .lc_dots{
        line-height: 10px;
    }

    .lc_dot {
        height: 6px;
        width: 6px;
        background-color: var(--color-gray1);
        border-radius: 50%;
        display: inline-block;
    }
    .lc_dot_selected {
        height: 6px;
        width: 6px;
        background-color: var(--color-purple);
        border-radius: 50%;
        display: inline-block;
    }


</style>